<div class="dialog-content">
  <h1 class="text-center">{{ "loginModal.sessionExpired" | translate }}</h1>
  <div class="main-container">
    <app-login-form
      [resetPasswordInDialog]="true"
      (loginFormSubmit)="loginFormSubmit($event)"
      (forgotPasswordClick)="onForgotPassword()"
    ></app-login-form>
  </div>
</div>
